
import Leyora101 from './Leyora 10 (1).webp'
import Leyora102 from './Leyora 10 (2).webp'
import Leyora103 from './Leyora 10 (3).webp'
import Leyora104 from './Leyora 10 (4).webp'
import Leyora105 from './Leyora 10 (5).webp'
import Leyora106 from './Leyora 10 (6).webp'
import Leyora107 from './Leyora 10 (7).webp'
import Leyora108 from './Leyora 10 (8).webp'
import Leyora109 from './Leyora 10 (9).webp'
import Leyora1010 from './Leyora 10 (10).webp'


const Leyora10images =[
Leyora101,Leyora102,Leyora103,Leyora104,Leyora105,Leyora106,Leyora107,Leyora108,Leyora109,Leyora1010
]

export default Leyora10images;